<div class="custom-edu-chat-window-wrapper">
  @if (chatWindowOpened) {
    <div class="custom-chat-window-content-wrapper">
      <div class="chat-window-content-header">
        <div class="content-header-title">{{ formTitle }}</div>
        <div class="content-header-text">{{ formMessage }}</div>
      </div>
      <div class="chat-window-content-form">
        @if (chatUser) {
          <form class="chat-form" novalidate (ngSubmit)="submitForm()">
            @if (errorMessage) {
              <div class="form-error-block">{{ errorMessage }}</div>
            }
            <div class="form-hint">* indicates a required field</div>
            <div class="form-group required">
              <label for="firstNameInput" class='control-label'>Name</label>
              <input id="firstNameInput" type="text" class="form-control" name="name" [(ngModel)]="chatUser.name" (keyup)="checkForm()" required
                [ngClass]="{'invalid-input': (formChecked && !chatUser.name || chatUser.name === '')}">
            </div>
            <div class="form-group required">
              <label for="emailInput" class='control-label'>Email</label>
              <input id="emailInput" type="email" class="form-control" name="email" [(ngModel)]="chatUser.email" (keyup)="checkForm()" required
                [ngClass]="{'invalid-input': (formChecked && !chatUser.email || chatUser.email === '')}">
            </div>
            @if (someoneAvailableToChat) {
              <div class="form-group required">
                <label for="phoneInput" class='control-label'>Phone</label>
                <input id="phoneInput" type="tel" class="form-control" [mask]="phoneMask" pattern="\d{3}-\d{3}-\d{4}" name="phone" [(ngModel)]="chatUser.phone" (keyup)="checkForm()" required
                  [ngClass]="{'invalid-input': (formChecked && !chatUser.phone || chatUser.phone === '')}">
              </div>
            }
            @if (!someoneAvailableToChat) {
              <div class="form-group required">
                <label for="commentsInput" class='control-label'>Message</label>
                <textarea id="commentsInput" class="form-control" name="message" [(ngModel)]="chatUser.message" rows="4"
                [ngClass]="{'invalid-input': (formChecked && !chatUser.message || chatUser.message === '')}"></textarea>
              </div>
            }
            <div class="chat-btn-group" role="group" aria-label="submit from">
              <button type="submit" class="btn btn-primary chat-button">{{ formButtonText }}</button>
            </div>
          </form>
        }
      </div>
    </div>
  }

  <div class="custom-chat-window-buttons-wrapper">
    @if (!chatWindowOpened) {
      <div class="chat-window-mock-button open-chat" (click)="openChat()">
        <svg viewBox="0 0 34 31" width="34" height="31" aria-hidden="true" role="img" fill="none">
          <title>Chat Icon</title>
          <desc>chat bubble with three dots indicates an agent is available to chat</desc>
          <path fill-rule="evenodd" clip-rule="eventodd" d="M8.61516 22.4845L3.35656 21.9322C2.01727 21.7915 1 20.6622 1 19.3154V6.44089C1 5.09407 2.01727 3.96471 3.35656 3.82401C9.10121 3.22057 23.8176 1.67437 30.0934 1.01451C30.8353 0.936259 31.5749 1.17703 32.1294 1.67588C32.6832 2.17473 33 2.88575 33 3.63139C33 8.31288 33 17.4426 33 22.1249C33 22.8705 32.6832 23.5808 32.1294 24.0804C31.5749 24.5792 30.8353 24.8192 30.0934 24.7417L14.8925 23.1444C13.4403 26.7304 10.0259 29.038 5.674 29.5414C5.45881 29.5624 5.25565 29.4375 5.17664 29.2359C5.09839 29.0342 5.1646 28.8048 5.33765 28.6746C7.20739 27.2518 8.36687 25.3655 8.61516 22.4845Z" stroke="white" stroke-width="2"></path>
          <circle cx="17" cy="13" r="2" fill="white"></circle>
          <circle cx="25" cy="13" r="2" fill="white"></circle>
          <circle cx="9" cy="13" r="2" fill="white"></circle>
        </svg>
        Have some questions?
      </div>
    }

    @if (chatWindowOpened) {
      <div class="chat-window-mock-button close-chat" (click)="closeChat()">
        <svg class="olark-close-icon" width="20" height="20" viewBox="0 0 20 20" aria-labelledby="olark-close-icon" aria-hidden="true" role="img">
          <title id="olark-close-icon">Close Icon</title>
          <desc>x to indicate you can close the chat</desc>
          <path d="M18 2L2 18" stroke="currentcolor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M2 2L18 18" stroke="currentcolor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </div>
    }
  </div>
</div>